import { render } from "./dashboard.html?vue&type=template&id=06819a4b&scoped=true&external"
import script from "./dashboard.ts?vue&type=script&lang=js&external"
export * from "./dashboard.ts?vue&type=script&lang=js&external"

import "./dashboard.scss?vue&type=style&index=0&id=06819a4b&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06819a4b"],['__file',"src/view/dashboard/dashboard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06819a4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06819a4b', __exports__)) {
    api.reload('06819a4b', __exports__)
  }
  
  module.hot.accept("./dashboard.html?vue&type=template&id=06819a4b&scoped=true&external", () => {
    api.rerender('06819a4b', render)
  })

}


export default __exports__